module.exports = __webpack_public_path__ + "img/img-verification-2.b61180e4.png";